// extracted by mini-css-extract-plugin
export var firstGlow = "styles-module--first-glow--fcd9f";
export var item = "styles-module--item--d5bcd";
export var list = "styles-module--list--ce08d";
export var mainWrapper = "styles-module--mainWrapper--f49e3";
export var statisticDescription = "styles-module--statistic-description--29596";
export var statisticTitle = "styles-module--statistic-title--322ad";
export var title = "styles-module--title--48a7e";
export var wrapper = "styles-module--wrapper--47406";